import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { ManageCampaignService } from 'src/app/private/services/manage-campaign.service';
import { UsersService } from 'src/app/private/services/users.service';
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-tempate.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { ClientService } from 'src/app/private/services/client.service';
import { Router } from '@angular/router';
import { CampaignService } from 'src/app/private/services/campaign.service';
import { EmailService } from 'src/app/private/services/email.service';


@Component({
  selector: 'app-broadcast-campaign',
  templateUrl: './broadcast-campaign.component.html',
  styleUrls: ['./broadcast-campaign.component.scss']
})
export class BroadcastCampaignComponent {

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  totalRows = 0;
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  initialLoad = true;
  reloading = false;
  emailTemplates: any[] = [];
  whatsappConfigs:any = "";
  emailConfig:any = "";
  whatsappTemplates: any[] = [];
  contactGroups: any[] = [];

  isFetchingTemplates = false;
  whatsappPreviewTemplate: any;
  processedData: any;
  attachments: any[] = [];
  isAdmin: boolean = false;
  filterArray:any = []
  active = "whatsapp"
organisationEmails : string[] = [];
  testEmail: string = '';
  testEmailLoading: boolean = false;
  launchState: 'idle' | 'launching' | 'success' | 'failed' = 'idle';
  launchErrorMessage: string = '';

  // Email Reputation
  reputationData: any = null;
  isReputationLoading: boolean = false;
  reputationError: string | null = null;
  // Email metrics bottom bar
  emailConfigData: any = null;          // full API response
  emailsWithMetrics: any[] = [];        // emails_with_metrics array
  selectedEmailIndex: number = 0;       // which email is selected in dropdown
  emailMetricsLoading: boolean = false;

  get selectedEmailEntry(): any {
    return this.emailsWithMetrics[this.selectedEmailIndex] ?? null;
  }
  get selectedEmailAddress(): string {
    return this.selectedEmailEntry?.email ?? '';
  }
  get selectedEmailReputation(): any {
    return this.selectedEmailEntry?.reputation ?? null;
  }
  get initialEmailLimit(): number {
    return this.emailConfigData?.initial_email_campaign_limit ?? 0;
  }
  campaign: any = {
    "id": "",
    "campaign_name": "",
    "contact_group_id": "",
    "campaign_source": "",
    "campaign_date": "",
    "subject": "",
    "template_id": "",
    "is_schedule": false,
    "status": "pending",
    "hospital_id": ""
  }

  displayedColumns: string[] = ["campaign_name", "campaign_group", "campaign_date",

    "is_schedule",
    "schedule_date",
    "schedule_time",
    "status", "action"];

  
    defaultFilter = [
      "campaign_name",
      "status",
    ]

  @ViewChild('connectSetting') connectSetting!: TemplateRef<any>;
  constructor(
    private toast: ToastrService,
    private api: ManageCampaignService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private sanitizer: DomSanitizer,
    private tracker: TrackingService,
    private ClientService:ClientService,
    private router:Router,
    private campaignService: CampaignService,
    private emailService: EmailService
  ) {
     this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  ngAfterViewInit() {
    this.fetchCampaigns();
    this.fetchContactGroups();
    this.fetchEmailTemplates();
    this.fetchWhatsAppTemplates();
    this.loadOrganisationEmails();

    // Re-fetch when search or date filter changes (reset to page 1)
    this.searchQuery.valueChanges.subscribe(() => this.fetchCampaigns(true));
    this.dateQuery.valueChanges.subscribe(() => this.fetchCampaigns(true));

    this.filterArray.push(
      { key: 'campaign_name', value: 'Campaign Name', type: 'text' },
      { key: 'status', value: 'Status', type: 'select', options: [
        'Pending',
        'Scheduled',
        'Completed',
      ] });
  }
  
 analytics(analyticsContent: TemplateRef<any> | null, element: any) {
  this.router.navigate(['main/email-campaign-anlaytics/'+element.id]);
  }
  
  whatsappAnalytics(element: any) {
    this.router.navigate(['main/whatsapp-campaign-analytics/'+element.id]);
  }

  

  fetchEmailTemplates() {

    const data : any = {
      "hospital_id": this.localStorage.getHospitalId(),
    }

    // if(!this.isAdmin) {
    //   data['user_id'] = this.localStorage.getUserId();
    // }

    const payload : any = {
      "where": {
        "hospital_id": this.localStorage.getHospitalId(),
      },
      "filter": null,
      "page": 0,
      "limit": 1000
    }

    if (!this.isAdmin) {
      payload.where.user_id = this.localStorage.getUserId();
    }

    this.api.getAllEmailTemplates(payload).subscribe((res: any) => {
      this.emailTemplates = this.sortByCreatedAtDesc(res?.rows);
    }
    );
  } 

  sortByCreatedAtDesc(data: any[]) {
  return [...data].sort((a, b) => {
    const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;

    return dateB - dateA; // DESC
  });
}
  fetchWhatsAppTemplates() {

    const param:any= {
      "hospital_id": this.localStorage.getHospitalId(),
      "status": "APPROVED"
    }

    if(!this.isAdmin) {
      param['user_id'] = this.localStorage.getUserId();
    }

    this.api.getAllTemplatesWithStatusFilter(param).subscribe((res: any) => {

      this.whatsappTemplates = this.sortByCreatedAtDesc(res);;
    }
    );
  }
  dateFilter(event: any) {
    console.log('Date Filter Event:', event);
    this.dateQuery.setValue(event);
  }

  fetchContactGroups() {
    const payload : any = {
      "where": {
        "hospital_id": this.localStorage.getHospitalId(),
      },
      "order": {
        "col": "\"contact_group\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if(!this.isAdmin) {
      payload.where.user_id = this.localStorage.getUserId();
    }

    this.api.getAllContactGroups(payload).subscribe((res: any) => {
      // Filter contact groups based on group_type (active type or 'both')
      const filteredGroups = res.filter((group: any) => 
        group.group_type === this.active || group.group_type === 'both'
      );
      this.contactGroups = this.sortByCreatedAtDesc(filteredGroups);
    }
    );
  }


  loadOrganisationEmails() {

  // this.organisationEmails = ['sales@domain.com','support@domain.com'];
 

   let payload: any = {

              where: {
                hospital_id: this.localStorage.getHospitalId()
              },
              order: {
                col: "",
                dir: ""
              }
            };

 this.ClientService.getAllClientConfig(payload).subscribe({
  next: (res: any) => {


    const selectedEmailConfig = this.getActiveEmailConfig(res);
    const selectedWhatsappConfig = this.getActiveWhatsappConfig(res);
    console.log('Selected WhatsappConfig config:', selectedWhatsappConfig);
    if (Array.isArray(selectedEmailConfig)) {
      const activeEmail = selectedEmailConfig.find(
        (config: any) => config?.is_active === true
      );

      if (activeEmail) {
       // console.log('Active email config found:', activeEmail);
        this.organisationEmails = activeEmail.settings.organisation_email|| [];
      
      } else {
        this.organisationEmails = [];
      }
    } else {
      console.warn('selectedEmailConfig is not an array:', selectedEmailConfig);
      this.organisationEmails = [];
    }
  },
  error: (err) => {

    console.error('Failed to load organisation emails', err);
    this.organisationEmails = [];
  }
});
}


getActiveEmailConfig(response: any): any | null {
  if (
    !response ||
    !response.rows ||
    !response.rows.length ||
    !response.rows[0].email_config
  ) {
    return null;
  }

  this.emailConfig = response.rows[0].email_config;
  return this.emailConfig;
}

getActiveWhatsappConfig(response: any): any | null {
  if (
    !response ||
    !response.rows ||
    !response.rows.length ||
    !response.rows[0].whats_app_config
  ) {
    return null;
  }

  this.whatsappConfigs = response.rows[0].whats_app_config || null;
  return this.whatsappConfigs;
}

  /** Single imperative fetch — called from ngAfterViewInit, (page) events, tab change, search/date changes */
  fetchCampaigns(resetPage = false) {
    try {
      if (resetPage) {
        this.currentPage = 0;
      }

      this.reloading = true;

      let payload: any = {
        where: {
          hospital_id: this.localStorage.getHospitalId(),
          campaign_type: this.active,
        },
        page: this.currentPage * this.pageSize,
        limit: this.pageSize,
        order: {
          col: '"campaign"."createdAt"',
          dir: 'DESC',
        },
      };

      if (this.searchQuery.value) {
        for (let [key, value] of Object.entries(this.searchQuery.value)) {
          if (this.defaultFilter.includes(key)) {
            payload.where = { ...payload.where, [key]: value };
          }
        }
      }

      if (this.dateQuery.value) {
        payload = { ...payload, ...this.dateQuery.value };
      }

      if (!this.isAdmin) {
        payload.where = { ...payload.where, user_id: this.localStorage.getUserId() };
      }

      this.api.getAllManangeCampaign(payload).subscribe({
        next: (response: any) => {
          this.initialLoad = false;
          this.reloading = false;
          this.btnLoading = false;
          this.totalRows = response?.count ?? 0;
          this.dataSource = new MatTableDataSource<any>(response?.rows ?? []);
        },
        error: (e: any) => {
          this.btnLoading = false;
          this.initialLoad = false;
          this.reloading = false;
          console.error(e);
        },
      });
    } catch (e) {
      this.reloading = false;
      console.error(e);
    }
  }

  /** Called from paginator (page) event on both tabs */
  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchCampaigns();
  }

  /** Kept for compatibility – just delegates to fetchCampaigns */
  loadData(type?: string) {
    this.fetchCampaigns();
  }

  reload(type?: string) {
    this.fetchCampaigns();
  }

  handleUpdateData(type?: string) {
    if (type === 'create') {
      this.toast.success('Campaign created successfully');
    } else if (type === 'update') {
      this.toast.success('Campaign updated successfully');
    } else if (type === 'delete') {
      this.toast.success('Campaign deleted successfully');
    }
    this.btnLoading = false;
    this.modalService.dismissAll();
    this.fetchCampaigns();
  }

  searchFilter(query: any) {
    console.log('Search Query:', query);
    this.searchQuery.setValue(query);
    // fetchCampaigns(true) is triggered by the valueChanges subscription in ngAfterViewInit
  }


  open(content: any) {
    // Check if WhatsApp configuration exists and is valid
    const isWhatsAppConfigured = this.whatsappConfigs && 
                                  (Array.isArray(this.whatsappConfigs) ? this.whatsappConfigs.length > 0 : true);
    
    // Check if campaign email is configured
    const isCampaignEmailConfigured = this.organisationEmails.filter((item: any) => item.type == 'campaign');
    
    console.log("WhatsApp Config:", this.whatsappConfigs);
    console.log("Is WhatsApp Configured:", isWhatsAppConfigured);
    console.log("Campaign Email Configured:", isCampaignEmailConfigured);
    
    // If WhatsApp campaign but WhatsApp is not configured
    if (this.active === 'whatsapp' && !isWhatsAppConfigured) {
      this.modalService.open(this.connectSetting, { size: 'lg', scrollable: true, centered: true });
      return;
    }
    
    // If email campaign but campaign email is not configured
    if (this.active === 'email' && isCampaignEmailConfigured.length === 0) {
      this.modalService.open(this.connectSetting, { size: 'lg', scrollable: true, centered: true });
      return;
    }
    
    // All checks passed, open the create campaign modal
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  changeTab(type: any) {
    this.active = type;
    this.initialLoad = true;
    this.currentPage = 0;  // reset to first page on tab switch
    this.dataSource = new MatTableDataSource<any>([]);
    this.fetchCampaigns();
    this.fetchContactGroups();
    if (type === 'email') {
      this.loadEmailMetrics();
    }
    this.campaign = {
      'id': '',
      'campaign_name': '',
      'contact_group_id': '',
      'campaign_source': '',
      'campaign_date': '',
      'subject': '',
      'template_id': '',
      'is_schedule': false,
      'status': 'pending',
      'hospital_id': ''
  };
  }

  edit(content: any, event: any) {
    this.modalService
      .open(content, { size: 'lg', scrollable: true, centered: true })
    this.campaign = event
    // this.id = event.id;
  }

  delete(content: any, event: any) {

  }

  handleGetWhatsappTemplateById(id: any) {

    this.isFetchingTemplates = true;
    const payload = {
      "hospital_id": this.localStorage.getHospitalId(),
      "template_id": id
    }
    this.api.getTemplateById(payload).subscribe(
      (res: any) => {
        this.whatsappPreviewTemplate = res;
        console.log("whatsapptemplate",this.whatsappPreviewTemplate)
        this.isFetchingTemplates = false
      },
      (error: any) => {
        this.isFetchingTemplates = false
        console.error('Error creating campaign', error);
      }
    );
  }

  handleGetEmailTemplateById(id: any) {
    this.isFetchingTemplates = true;
    const payload = {
      "hospital_id": this.localStorage.getHospitalId(),
      "template_id": id
    }
    this.api.getEmailTemplateById(payload).subscribe(
      (res: any) => {
        console.log("emailtemplate",res)
        this.processedData =  this.sanitizer.bypassSecurityTrustHtml(res.template_body); 
        this.attachments = res.attachments;
        this.isFetchingTemplates = false
      },
      (error: any) => {
        this.isFetchingTemplates = false
        console.error('Error creating campaign', error);

      }

    );
  }

  run(content: any, event: any) {
    this.campaign = event;

    if(this.active === 'whatsapp') {
      this.handleGetWhatsappTemplateById(event.template_id);
    }else if(this.active === 'email') {
      this.handleGetEmailTemplateById(event.template_id);
    }
    
    this.modalService
      .open(content, { size: 'md', centered: true })

  }

  connectCampaign() {
    this.modalService.dismissAll();
    if(this.active=='whatsapp') {
      this.router.navigate(['/main/client-settings','whatsapp']);
    }else if(this.active=='email') {
      this.router.navigate(['/main/client-settings','notification']);
    }
  }
  runCampaign() {
    try {
      // Validate required fields
      if (!this.campaign.contact_group_id) {
        this.toast.error('Please select a contact group', 'Validation Error');
        return;
      }

      if (!this.campaign.template_id) {
        this.toast.error('Please select a template', 'Validation Error');
        return;
      }

      this.btnLoading = true;
      this.launchState = 'launching';

      const payload = {
        broadcastType: this.active,
        hospital_id: this.localStorage.getHospitalId(),
        contact_group_id: this.campaign.contact_group_id,
        template_id: this.campaign.template_id,
        subject: this.active === 'email' ? this.campaign?.subject : null,
        campaign_id: this.campaign?.id,
        is_schedule: this.campaign.is_schedule,
      };

      console.log('Run campaign payload:', payload);

      this.api.runCampaign(payload).subscribe({
        next: (res: any) => {
          const desc = `Campaign run for campaign ID: ${payload.campaign_id}, type: ${payload.broadcastType}, campaign name: ${this.campaign?.campaign_name} and campaign type: ${this.active}`;
          this.tracker.track('Run', 'Broadcast Campaign', desc);
          this.btnLoading = false;
          this.launchState = 'success';
          // Auto-close after showing success for 2.5 s
          setTimeout(() => {
            this.launchState = 'idle';
            this.modalService.dismissAll();
            this.loadEmailMetrics();
            this.reload();
          }, 2500);
        },
        error: (error: any) => {
          console.error('Error running campaign:', error);
          this.btnLoading = false;

          // Extract error message from various possible structures
          let errorMessage = 'Failed to run campaign. Please try again.';
          if (error?.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }

          this.launchErrorMessage = errorMessage;
          this.launchState = 'failed';
        }
      });
    } catch (error: any) {
      console.error('Unexpected error running campaign:', error);
      this.btnLoading = false;
      this.launchErrorMessage = 'An unexpected error occurred. Please try again.';
      this.launchState = 'failed';
    }
  }

  resetLaunchState() {
    this.launchState = 'idle';
    this.launchErrorMessage = '';
    this.btnLoading = false;
    this.modalService.dismissAll();
  }

  deleteCampaign() {
    try {
      // Validate campaign ID
      if (!this.campaign?.id) {
        this.toast.error('Invalid campaign. Please try again.', 'Validation Error');
        return;
      }

      this.btnLoading = true;
      console.log('Deleting campaign:', this.campaign);

      const payload = {
        id: this.campaign.id
      };

      this.api.deleteCampaign(payload).subscribe({
        next: (res: any) => {
          const desc = `Broadcast campaign deleted with ID: ${payload.id}, name: ${this.campaign.campaign_name} and type: ${this.active}`;
          this.tracker.track('Delete', 'Broadcast Campaign', desc);
          this.handleUpdateData('delete');
        },
        error: (error: any) => {
          console.error('Error deleting campaign:', error);
          this.btnLoading = false;
          
          // Extract error message from various possible structures
          let errorMessage = 'Failed to delete campaign. Please try again.';
          
          if (error?.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }
          
          this.toast.error(errorMessage, 'Delete Error');
        }
      });
    } catch (error: any) {
      console.error('Unexpected error deleting campaign:', error);
      this.btnLoading = false;
      this.toast.error(
        'An unexpected error occurred while deleting. Please try again.',
        'Error'
      );
    }
  }

  loadEmailMetrics() {
    this.emailMetricsLoading = true;
    const param = {
      hospital_id: this.localStorage.getHospitalId(),
    };
    this.emailService.getEmailConfigById(param).subscribe({
      next: (res: any) => {
        this.emailConfigData = res ?? null;
        this.emailsWithMetrics = res?.emails_with_metrics ?? [];
        this.selectedEmailIndex = 0;
        this.emailMetricsLoading = false;
      },
      error: (err: any) => {
        console.error('Error loading email config:', err);
        this.emailConfigData = null;
        this.emailsWithMetrics = [];
        this.selectedEmailIndex = 0;
        this.emailMetricsLoading = false;
      }
    });
  }

  selectEmailEntry(index: number) {
    this.selectedEmailIndex = index;
  }

  navigateToEmailConfiguration() {
    this.router.navigate(['/main/client-settings', 'notification']);
  }

  // Open test email modal
  openTestEmailModal(modal: any) {
    this.modalService.open(modal, { size: 'md', centered: true });
  }

  // Directly open test email modal from card list (email campaigns only)
  directTestCampaign(testEmailModalRef: any, element: any) {
    this.campaign = element;
    this.testEmail = '';
    this.modalService.open(testEmailModalRef, { size: 'md', centered: true });
  }

  // Send test email
  sendTestEmail(modal: any) {
    try {
      // Validate test email input
      if (!this.testEmail) {
        this.toast.error('Please enter at least one email address', 'Validation Error');
        return;
      }

      // Split by comma and trim whitespace
      const emailArray = this.testEmail
        .split(',')
        .map(email => email.trim())
        .filter(email => email.length > 0);

      if (emailArray.length === 0) {
        this.toast.error('Please enter valid email addresses', 'Validation Error');
        return;
      }

      // Validate each email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const invalidEmails = emailArray.filter(email => !emailRegex.test(email));

      if (invalidEmails.length > 0) {
        this.toast.error(
          `Invalid email format: ${invalidEmails.join(', ')}`,
          'Validation Error'
        );
        return;
      }

      // Validate campaign data
      if (!this.campaign?.id || !this.campaign?.template_id) {
        this.toast.error('Invalid campaign data. Please try again.', 'Validation Error');
        return;
      }

      this.testEmailLoading = true;

      const payload = {
        hospital_id: this.localStorage.getHospitalId(),
        contact_group_id: this.campaign.contact_group_id,
        campaign_id: this.campaign.id,
        template_id: this.campaign.template_id,
        test_emails: emailArray
      };

      console.log('Test email payload:', payload);

      this.api.testCampaignEmail(payload).subscribe({
        next: (res: any) => {
          this.testEmailLoading = false;
          const emailCount = emailArray.length;
          const emailList = emailArray.length > 3 
            ? `${emailArray.slice(0, 3).join(', ')}... (${emailCount} total)`
            : emailArray.join(', ');
          
          this.toast.success(
            `Test email sent successfully to ${emailList}`,
            'Success'
          );
          
          this.tracker.track(
            'Test Email', 
            'Broadcast Campaign', 
            `Test email sent for campaign: ${this.campaign?.campaign_name} to ${emailCount} recipient(s): ${emailArray.join(', ')}`
          );
          
          modal.dismiss('Cross click');
          this.testEmail = ''; // Reset
        },
        error: (error: any) => {
          this.testEmailLoading = false;
          console.error('Error sending test email:', error);
          
          // Extract error message from various possible structures
          let errorMessage = 'Failed to send test email. Please check your email configuration and try again.';
          
          if (error?.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }
          
          this.toast.error(errorMessage, 'Test Email Error');
        }
      });
    } catch (error: any) {
      console.error('Unexpected error sending test email:', error);
      this.testEmailLoading = false;
      this.toast.error(
        'An unexpected error occurred while sending test email. Please try again.',
        'Error'
      );
    }
  }


}

